var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16666 19.3333C2.16666 29.4586 10.3748 37.6667 20.5 37.6667V1C10.3748 1 2.16666 9.20811 2.16666 19.3333Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.8334C15.75 14.3397 15.3396 14.7501 14.8334 14.7501C14.3271 14.7501 13.9167 14.3397 13.9167 13.8334C13.9167 13.3272 14.3271 12.9167 14.8334 12.9167C15.3396 12.9167 15.75 13.3272 15.75 13.8334Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.8333H19",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 24.3333C41.5 34.4586 33.2919 42.6667 23.1667 42.6667V6C33.2919 6 41.5 14.2081 41.5 24.3333Z",
    fill: "#AFBBE1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 17.8334C29.75 18.3397 29.3396 18.7501 28.8334 18.7501C28.3271 18.7501 27.9167 18.3397 27.9167 17.8334C27.9167 17.3272 28.3271 16.9167 28.8334 16.9167C29.3396 16.9167 29.75 17.3272 29.75 17.8334Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 30.8333H30",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.1429L35 28M35 28L38 25.1429M35 28L35 23",
    stroke: "#6475A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroke);
export default __webpack_public_path__ + "static/media/stroke.568dd9e0c6aa26e1cd5ebdff67b4ddee.svg";
export { ForwardRef as ReactComponent };